<template>
  <div class="filling-goods-div">
    <div style="padding-top: 5px; font-size: 16px">坯布自动领料出库</div>
    <div class="filling-goods-head-p" :class="{ 'hidden': keyboardOpen }">
      <div class="filling-goods-head-div" v-if="outNumber !== '未出库'">
        <div class="head-input-div-p">
          <div style="width: 20%; text-align: left;font-size: 0.48rem;">编号:</div>
          <input
            style="width: 80%"
            readonly="readonly"
            class="number"
            v-model="out_num"
          />
        </div>
        <div class="head-input-div-p">
          <div style="width: 20%; text-align: left;font-size: 0.48rem;">卷号:</div>
          <input style="width: 80%" readonly="readonly" v-model="reeldata" />
        </div>
        <!-- <div class="head-input-div-p">
          <div style="width: 20%; text-align: left;font-size: 0.48rem;">行数:</div>
          <input style="width: 80%" readonly="readonly" :value="data.length" />
        </div> -->
      </div>
      <div class="filling-goods-head-div">
        <div class="head-input-div-p">
          <div style="width: 20%; text-align: left;font-size: 0.48rem;">供应商:</div>
          <input style="width: 80%" readonly="readonly" :value="supplier_xh" />
        </div>
        <div class="head-input-div-p">
          <div style="width: 20%; text-align: left;font-size: 0.48rem;">货号:</div>
          <input style="width: 80%" readonly="readonly" :value="goodsnumber" />
        </div>
        <div class="head-input-div-p">
          <div style="width: 20%; text-align: left;font-size: 0.48rem;">现存量:</div>
          <input
            style="width: 80%"
            readonly="readonly"
            name="normsware"
            :value="count"
          />
        </div>
      </div>
    </div>
    <span style="color: red" v-if="hostcs">测试服</span>
    <div
      style="display: flex; justify-content: space-between; align-items: center"
      v-if="outNumber === '未出库'"
    >
      <van-button
        type="info"
        size="small"
        style="display: flex"
        :text="ray"
        @click="holdRay()"
      ></van-button>
      <div style="display: flex; flex-wrap: wrap; width: 5rem;font-size: 22px;">
        <input
          id="reel-input"
          style="margin-bottom: 10px;height: 25px; width: 4.5rem;"
          @keyup.enter="goGck()"
          ref="getIDInpot"
          v-model="reeldata"
          v-on:blur="hideMessage('reeldata')"
          readonly
          autocomplete="off"
        />
        <input
          id="gck_number-input"
          style="height: 25px; width: 4.5rem;"
          @keyup.enter="add_mx(gck_number_data)"
          ref="getGCKInpot"
          v-model="gck_number_data"
          v-on:blur="hideMessage('gck_number_data')"
          readonly
          autocomplete="off"
        />
      </div>
    </div>
    <div :style="style">
      <div class="goods-info-two" v-for="(i, index) in data" :key="index" style="padding-top: 10px;">
        <div class="info-order-h">
          <span style="margin-right: 20px">{{
            i["gck_number"] || i["mxm"]
          }}</span>
          <!--<span v-if="infoType === '1111'">{{i['num']}}米</span>-->
          <!--<span v-if="infoType === '1111'">* {{i['price']}}片 =</span>-->
          <span>
            <div v-if="outNumber === '未出库'">
              <input v-model="i['all_num']" v-on:blur="countAll()" type="number" v-on:focus="keyFocus()" style="width: 105px; height: 25px;"/>
              米
            </div>
            <div v-else>{{ i["all_num"] }}米</div>
          </span>
          <span>
            <div @click="writeIn(index)" style="margin-left: 20px;"  v-if="outNumber === '未出库'">系统算料：{{ i["Tall_num"] }}</div>
          </span>
        </div>
        <div>
          <van-icon
            name="cross"
            @click="deleteData(index, i['gck_number'])"
            style="margin: 5px 0"
          />
        </div>
      </div>
    </div>
    <div style="text-align: left; font-size: 16px">共计{{ allcount }}米</div>
    <van-popup v-model="show_print" style="width: 200px;">
      <div style="padding:10px;" class="print-only" id="popupPrint">
        <div>
          <div class="list-data">
            <div class="list-data-div">货号:</div>
            <div class="list-data-div">{{ Dydata.number }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div">数量:</div>
            <div class="list-data-div">{{ Dydata.store }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">供应商名称:</div>
            <div class="list-data-div-a">{{ Dydata.supplier }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">供应商型号:</div>
            <div class="list-data-div-a">{{ Dydata.supplier_xh }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">缸号:</div>
            <div class="list-data-div-a">{{ Dydata.cylinder_number }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">门幅:</div>
            <div class="list-data-div-a">{{ Dydata.menfu }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">备注:</div>
            <div class="list-data-div-a">{{ Dydata.reel_detail }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">时间:</div>
            <div class="list-data-div-a">{{ Dydata.nowtime }}</div>
          </div>
        </div>
        <Barcode :JsBarcodeData="JsBarcodeConfigData" />
      </div>
      <van-button type="info" @click="dayin()" style="width: 100px; margin : 10px;">打印</van-button>
    </van-popup>
    <div class="filling-goods-bottom" style="display: flex">
      <van-button type="warning" class="bottom-button" @click="go_index()"
        >回首页</van-button
      >
      <van-button
        v-if="outNumber === '未出库'"
        type="info"
        class="bottom-button"
        @click="fillingGoods()"
        >确认出库</van-button
      >
      <van-button
        v-if="outNumber !== '未出库'"
        type="default"
        class="bottom-button"
        style="background-color: darkgray"
        >确认出库</van-button
      >
      <van-button
        v-if="outNumber !== '未出库'"
        type="info"
        class="bottom-button"
        @click="revocation(id)"
        >撤销出库</van-button
      >
      <van-button
        v-if="outNumber === '未出库'"
        type="default"
        class="bottom-button"
        style="background-color: darkgray"
        >撤销出库</van-button
      >
      <van-button
        type="warning"
        class="bottom-button"
        style="margin: 0"
        @click="more_show = true"
      >
        更多
      </van-button>
      <van-button
        class="bottom-button"
        type="warning"
        style="width: 10%"
        @click="resetClick()"
      >
        +
      </van-button>
    </div>
    <van-popup v-model="more_show" position="bottom">
      <div class="more-class">
        <van-icon name="scan" size="1rem" @click="gourl('fillingGoods')" />
      </div>
      <div class="more-class" style="padding: 10px 0">
        <span style="font-size: 20px" @click="all_delete()">整单删除</span>
      </div>
      <div class="more-class" style="padding: 10px 0">
        <span style="font-size: 20px" @click="go_print()">打印现存量</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import Barcode from '@/components/Barcode';
import html2canvas from 'html2canvas';
import moment from 'moment';
export default {
  name: "orderInfo",
  components: {
    Barcode
  },
  data() {
    return {
      hostcs: false,
      more_show: false,
      ray: "扫描中",
      id: "",
      supplier_xh: "",
      count: "",
      goodsnumber: "",
      data: [],
      style: "",
      allcount: 0,
      reeldata: "",
      out_num: "",
      infoType: "1111",
      gck_number_data_haveAll: {},
      gck_number_data: "",
      fillingGoodsType: true,
      revocationType: true,
      outNumber: "未出库",
      username: "",
      type: "orderInfo",
      count: "",
      show_print: false,
      keyboardOpen: false,
      Dydata:{},
      JsBarcodeConfigData: {
        text: '', // 条形码必须是字符串类型，否则会出现后面几位为数字的情况。
        lineColor: "#000000", //二维码颜色
        background: "#fff", //二维码背景色
        //width: this.widthStyleObj, 
        bottomtext: '',
      }
    };
  },
  mounted() {
    let reel = this.$route.query.reel
    this.reeldata = reel
    if (typeof this.reeldata !== 'undefined') {
      if(this.reeldata.length > 0){
         this.goGck()
      }
    }
    this.username = JSON.parse(window.localStorage.getItem("userinfo"));
    if (this.$route.query.id !== undefined) {
      this.getIdData(this.$route.query.id);
    }
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.35 + "px;overflow:scroll";
    setTimeout(() => {
      this.countAll();
      if (this.outNumber === "未出库") {
        this.focus();
      }
    }, 500);
    if (window.location.host.indexOf("cspda") !== -1) {
      this.hostcs = true;
    }
  },
  methods: {
    resetClick() {
      if (this.outNumber === "未出库") {
        Dialog.confirm({
          title: "当前领料出库单未出库，是否要放弃当前出库单",
        }).then(() => {
          this.$router.push({ path: "/orderInfo" });
          window.location.reload();
        });
      } else {
        this.$router.push({ path: "/orderInfo" });
        window.location.reload();
      }
    },
    goGck() {
      // 输入卷号 弹出现存量
      this.get("/business/getNormsware", { reel: this.reeldata }).then(
        (res) => {
          this.count = res.data.store;
          this.goodsnumber=res.data.number;
          this.supplier_xh=res.data.supplier_xh;
        }
      );

      this.gck_input();
    },
    writeIn(i){
      //console.log(this.data[i].all_num);
      this.$set(this.data[i],'all_num', this.data[i]["Tall_num"]);
      if(this.data[i].all_num){ this.countAll() };
    },
    gck_input() {
      this.$refs.getGCKInpot.focus();
      this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getGCKInpot.removeAttribute("readonly");
      }, 200);
    },
    go_print(){
        this.get(this.APIOBJ.ClothAdjustment, { reel: this.reeldata }).then(
          (res) => {
            if (res.data.status == 1) {
              this.Dydata=res.data.data;
              this.Dydata.nowtime = moment().format('YYYY-MM-DD HH:mm:ss');
              this.JsBarcodeConfigData.text = this.reeldata;
              this.JsBarcodeConfigData.bottomtext = this.reeldata;
              this.show_print=true;
            } else{
              Toast('拉取失败');
            }
          }
        )   
    },
    dayin() {
      html2canvas(document.querySelector("#popupPrint")).then((canvas) => {
        //document.body.appendChild(canvas);
        var imageBase64 = canvas.toDataURL();// 将imageData作为参数传递给callAndroid()方法
        var imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
        this.callAndroid(imageBase64);
      });
    },
    callAndroid(imageBase64) {
      var BASE64_ENCODED_IMAGE_DATA = imageBase64;
      var imageData = BASE64_ENCODED_IMAGE_DATA;
      console.log(imageData);
      this.show_print = false;
      Android.receiveImage(imageData);
      alert("printPreview");
    },
    all_delete() {
      if (this.outNumber === "已出库") {
        Toast("已出库不能删除");
        return;
      }
      Dialog.confirm({
        message: "确定要删除当前出库单吗？",
      }).then(async () => {
        let s = await this.get(this.APIOBJ.outDel, {
          id: this.id,
          username: this.username,
        });
        Toast(s.data.msg);
        if (s.data.status === 1) {
          setTimeout(() => {
            this.$router.push("/home");
          }, 500);
        }
      });
    },
    keyFocus(){
      this.keyboardOpen = true;
      // const input = document.querySelector('input[type=text]');
      // if (this.keyboardOpen) {
      //   input.style.height = '50vh'; // 调整输入框高度为屏幕高度的一半
      // } else {
      //   input.style.height = ''; // 恢复默认高度
      // }
    },
    countAll() {
      //计算总量
      this.keyboardOpen = false;
      this.allcount = 0;
      for (let i of this.data) {
        this.allcount += parseFloat(i["all_num"]);
      }
      this.allcount = this.allcount.toFixed(1);
    },
    hideMessage(title) {
      if (title === "reeldata") {
        if (this.reeldata === "") {
          this.ray = "已暂停，点击我继续扫码";
        }
      }
      if (title === "gck_number_data") {
        if (this.gck_number_data === "") {
          this.ray = "已暂停，点击我继续扫码";
        }
      }
    },
    holdRay() {
      this.ray = "扫描中";
      if (this.reeldata === "") {
        this.focus();
      } else if (this.gck_number_data === "") {
        this.gck_input();
      }
    },
    focus() {
      this.$refs.getIDInpot.focus();
      this.$refs.getIDInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getIDInpot.removeAttribute("readonly");
      }, 200);
    },
    gourl(url) {
      url = "http://www.lcyjfz.com/home/scan?url=" + url;
      window.location.href = url;
    },
    async add_mx(gck_number_title) {
      console.log(gck_number_title)
      if(gck_number_title.indexOf('-') !== -1){
        // 说明有 -
        let index = gck_number_title.indexOf('-')
        gck_number_title = gck_number_title.substring(0 , index)
      }
      console.log(gck_number_title)
      if (this.gck_number_data_haveAll[gck_number_title] !== undefined) {
        Toast("明细码不能重复");
        this.gck_number_data = "";
        return;
      }
      this.gck_number_data_haveAll[gck_number_title] = "";
      let packing = await this.get(this.APIOBJ.outOne, {
        reel: this.reeldata,
        gck_number: gck_number_title,
      });
      if (packing.data.status !== 0) {
        let newData = {};
        if (
          packing.data.data.gf === "沈矮峰" ||
          packing.data.data.gf === "沈高峰"
        ) {
          if(localStorage.getItem('enterpriseCode')!=='aml'){
            Dialog.confirm({
            cancelButtonText: "取消写入",
            confirmButtonText: "确认写入",
            showCancelButton: true,
            message:
              "系统没有匹配到，相应的型号，可能是下单人员，填写不工整，请您自行判断。是否要强制写入当前出库单",
          })
            .then(() => {
              newData["number"] = gck_number_title;
              newData["gck_number"] = gck_number_title;
              newData["Tall_num"] = "";
              this.data.push(newData);
            })
            .catch(() => {
              delete this.gck_number_data_haveAll[gck_number_title];
            });
          }else{
            Dialog.alert({
            //cancelButtonText: "取消写入",
            confirmButtonText: "取消",
            //showCancelButton: true,
            message:
              "系统没有匹配到，相应的型号，可能是下单人员，填写不工整，请您自行判断。是否要强制写入当前出库单",
          })
            .then(() => {
              // newData["number"] = gck_number_title;
              // newData["gck_number"] = gck_number_title;
              // newData["all_num"] = "";
              // this.data.push(newData);
              delete this.gck_number_data_haveAll[gck_number_title];
            })
            // .catch(() => {
            //   delete this.gck_number_data_haveAll[gck_number_title];
            // }); 
          }
        } else {
          packing.data.data["gck_number"] = gck_number_title;
          packing.data.data["Tall_num"] = (
            packing.data.data["num"] * packing.data.data["price"]
          ).toFixed(1);
          packing.data.data["normsware"] = packing.data.data.normsware;
          this.data.push(packing.data.data);
          // this.count = packing.data.data.normsware;
        }
      } else {
        console.log(packing)
        Toast(packing.data.msg);
      }
      //this.supplier_xh = packing.data.data["supplier_xh"];
      this.gck_input();
      this.gck_number_data = "";
      //this.countAll();
    },
    deleteData(index, gck_number_data) {
      if (this.outNumber === "已出库") {
        Toast("已出库不能删除");
        return;
      }
      Dialog.confirm({
        message: "确定要删除该明细吗？",
      }).then(() => {
        let mxm = this.data[index].mxm | this.data[index].gck_number;
        this.data.splice(index, 1);
        delete this.gck_number_data_haveAll[mxm];
        setTimeout(() => {
          this.countAll();
        }, 0);
      });
    },
    go_index() {
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },
    go_scan_url() {
      let url =
        "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
      window.location.href = url;
    },
    async getIdData(id) {
      //订单详情页
      let idData = await this.get(this.APIOBJ.out_detail, { id });
      this.count = Number(idData.data.data.out.normsware).toFixed(2);
      this.data = idData.data.data.out_detail;
      this.outNumber = idData.data.data.out.status;
      this.reeldata = idData.data.data.out_detail[0].reel;
      for (let i of idData.data.data.out_detail) {
        this.gck_number_data_haveAll[i.mxm] = "";
      }
      this.infoType = "";
      this.out_num = idData.data.data.out.out_num;
      this.supplier_xh = idData.data.data.out_detail[0].supplier_xh;
      this.goodsnumber = idData.data.data.out_detail[0].number;
      this.id = id;
    },
    async getFGIdData(FGid) {},
    async fillingGoods() {
      console.log(this.fillingGoodsType);
      if (this.data.length === 0) {
        return;
      }
      if (!this.fillingGoodsType) {
        Toast("不要连续出库");
        return;
      }
      this.fillingGoodsType = false;
      let out_info;
      if (this.id === "") {
        let data = {
          reel: this.reeldata,
          gck_number: "",
          number: "",
          num: "",
          username: "",
          type: this.type,
        };
        for (let i of this.data) {
          if (i["all_num"] === "" || i["all_num"] === undefined) {
            Toast("数量不能为空");
            this.fillingGoodsType = true;
            return;
          }
          data.gck_number += i.gck_number + ",";
          data.number += i.number + ",";
          data.num += i["all_num"] + ",";
        }
        data.username = this.username;
        for (let i in data) {
          data[i] =
            data[i].substring(data[i].length - 1) === ","
              ? data[i].substring(0, data[i].length - 1)
              : data[i];
        }
        out_info = await this.get(this.APIOBJ.doOut, data);
      } else {
        let data = {
          reel: this.reeldata,
          gck_number: "",
          number: "",
          num: "",
          id: this.id,
          username: "",
          type: this.type,
        };
        for (let i of this.data) {
          if (i["all_num"] === "" || i["all_num"] === undefined) {
            Toast(`${i.mxm || i.gck_number}数量为空`);
            this.fillingGoodsType = true;
            return;
          }
          data.gck_number += (i.mxm || i.gck_number) + ",";
          data.number += i.number + ",";
          data.num += i["all_num"] + ",";
        }
        data.username = this.username;
        for (let i in data) {
          if (i !== "id") {
            data[i] =
              data[i].substring(data[i].length - 1) === ","
                ? data[i].substring(0, data[i].length - 1)
                : data[i];
          }
        }
        out_info = await this.get(this.APIOBJ.outEdit, data);
      }
      if (out_info.data.status === 1) {
        Toast("成功");
      }else{
        Toast(out_info.data.msg)
      }
      this.id = out_info.data.data.out_detail[0].oid;
      this.fillingGoodsType = true;
      this.outNumber = out_info.data.data.out.status;
      this.infoType = "";
      this.out_num = out_info.data.data.out.out_num;
    },
    async revocation(id) {
      if (!this.revocationType) {
        return;
      }
      this.revocationType = false;
      let out_info = await this.get(this.APIOBJ.backOut, {
        id: id,
        username: this.username,
      });
      this.outNumber = "未出库";
      if (out_info.data.status === 1) {
        Toast("已撤销");
      }
      this.infoType = "1111";
      this.revocationType = true;
    },
  },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";
.filling-goods-head-p{
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
}
.head-input-div-p{
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
  font-size: 20px;
  margin-bottom: 10px;
}
.list-data {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.list-data-div {
  padding-right: 3px;
  text-align: left;
  font-size: 18px;
}

.list-data-div-a {
  padding-right: 3px;
  text-align: left;
  font-size: 14px;
}
.hidden {
  display: none;
}
</style>